import React from 'react';
import {BreadcrumbContainer, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator} from './styles';
import { BreadcrumbItemTypes } from '@/store/types/breadcrumbTypes';

interface BreadcrumbsProps {
    items: BreadcrumbItemTypes[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
    return (
        <BreadcrumbContainer>
            {items.map((item, index) => (
                <React.Fragment key={index}>
                    <BreadcrumbItem>
                        <BreadcrumbLink href={item.url}>{item.title}</BreadcrumbLink>
                    </BreadcrumbItem>
                    {index < items.length - 1 && (
                        <BreadcrumbSeparator />
                    )}
                </React.Fragment>
            ))}
        </BreadcrumbContainer>
    );
};

export default Breadcrumbs;